import { DS_HEIGHT, DS_SHAPE_SPACING } from '@calm/evexia-design-tokens';
import commonMessages from '@rhg/lang/messages/common';
import { Button, Theme } from '@rhg/libs/material';
import { useIntl } from 'react-intl';
import CHLink from '../ch-link';

const styleRoot = {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
    position: 'fixed',
    left: -1000,
    borderRadius: 0,
    top: `${DS_HEIGHT.TOOLBAR + DS_SHAPE_SPACING.BASE}px`,
    ['&:focus']: {
        left: 0,
    },
};

export const MAIN_CONTENT_ID = 'main-content';

export default function SkipToMain() {
    const { formatMessage } = useIntl();
    return (
        <Button
            sx={styleRoot}
            component={CHLink}
            href={`#${MAIN_CONTENT_ID}`}
            variant="contained"
            color="secondary"
            trackButton="SkipToMain"
        >
            {formatMessage(commonMessages['common.skip_to_main'])}
        </Button>
    );
}
